<p-dialog
    [(visible)]="visible"
    [appendTo]="appendTo"
    [contentStyle]="contentStyle"
    [dismissableMask]="dismissOnClickOutside"
    [draggable]="draggable"
    [minX]="minX"
    [minY]="minY"
    [modal]="blockBackground"
    (onHide)="onHide()"
    (onShow)="onShow()"
>
    <ng-template #header>
        {{ imageName }}
    </ng-template>

    <img
        [attr.src]="imagePreview | safeHtml"
        [class]="imageClass"
    />
</p-dialog>
